import { ENDPOINT_REQUEST, sendMsg, SERVICES_REQUEST } from "../../configurations";

export const IPOServices = {
  getApplicationService,
  getApplicationStatusEnquiryService,
  allotmentResultEnquireService,
  getListedFocusService,
  getDetailEnquiryService,
  getApplyResultService,
  ipoCancelService,
  ipoAppliedDetailsEnquiryService,
  ipoModifyService,
  getQueryIPOInterestRatePlanFeeService,
}

function getApplicationService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.LISTING_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function getApplicationStatusEnquiryService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.APP_STATUS_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function allotmentResultEnquireService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.ALLOTMENT_RESULT, params).get(res => {
    callback(res);
  });
}

function ipoCancelService(params,callback){
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.CANCEL, params).post(res => {
    callback(res);
  });
}

function getListedFocusService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.LISTED_FOCUS, params).get(res => {
    callback(res);
  })
}

function getDetailEnquiryService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.DETAIL_ENQUIRY, params).get(res => {
    callback(res.result);
  })
}

function getApplyResultService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.APPLY, params).post(res => {
    callback(res.result);
  })
}

function ipoAppliedDetailsEnquiryService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.APPLIEDDETAILSENQUIRY, params).get(res => {
    callback(res.result);
  })
}

function ipoModifyService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.IPOMODIFY, params).post(res => {
    callback(res.result);
  })
}

function getQueryIPOInterestRatePlanFeeService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iIPO.QUERY_IPO_INTEREST_RATE_PLAN_FEE, params).get(res => {
    callback(res.result);
  })
}